<template>
  <el-container class="default-layout">
    <the-aside/>
    <el-container class="main-container">
      <el-header>
        <the-header/>
      </el-header>

      <div class="page-main-wrapper page-main-wrapper_left-hidden">
        <portal-target
            ref="leftMenu"
            name="layout_left_menu"
            class="page-main-wrapper__left-panel"
        ></portal-target>

        <div class="page-main-wrapper__content" >
          <portal-target

              name="layout_nav_items"
          ></portal-target>
          <el-main
              :style="{ paddingBottom: '20px' }"
              class="main-block"
              id="main-block"
          >
            <router-view/>
          </el-main>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import {mapState} from "vuex";
import TheAside from "../components/TheAside";
import TheHeader from "../components/TheHeader";

export default {
  name: "session",
  components: {
    TheHeader,
    TheAside,
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState("loader", {
      loading: (state) => state.loading,
    }),

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 100%;

  @media only screen and (max-width: 500px) {
    display: block;
  }
}

.main-block {
  padding: 0;
}

.default-layout {
  height: 100vh;

  .el-main {
    padding-bottom: 0 !important;
    position: relative;

    overflow: hidden !important;
  }

  .infinite-status-prompt {
    font-size: 25px;
    margin-top: 25px;
    color: #e0e0e0;
  }

  .page-main-wrapper {
    flex-direction: row;
    display: flex;
    flex: 1;
    flex-basis: auto;
    overflow: hidden;
    min-height: 100vh;

    &__left-panel {
      flex: 0 200px;

      position: relative;
      min-width: 200px;
      overflow: auto;
    }

    &__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-width: calc(100% - 200px);
    }

    &_left-hidden {
      .page-main-wrapper__left-panel {
        flex: 0;
        min-width: auto;
      }

      .page-main-wrapper__content {
        max-width: 100%;
      }
    }
  }
}
</style>
